import { apiClient } from "@/api/api-client";
import createBaseService from "@/api/base-service.ts";
import type { z } from "zod";
import type {
	Article,
	ArticleFormSchema,
	uploadTiptapFormSchema,
} from "../../types/article";

const articleService = {
	...createBaseService<Article>("/articles"),
	updateById: async (data: ArticleFormSchema) => {
		const response = await apiClient.post<{ data: Article }>(
			`/articles/${data.id}`,
			data,
		);

		return response.data.data;
	},
	restoreById: async (id: string) => {
		await apiClient.post("/articles-restore", { id: id });
	},
	deleteById: async (id: string) => {
		await apiClient.delete(`/articles/${id}`);
	},
	deleteByIdPermanently: async (id: string) => {
		await apiClient.post("/articles-delete-permanently", { id: id });
	},
	uploadImage: async (values: z.infer<typeof uploadTiptapFormSchema>) => {
		const formData = new FormData();

		formData.append("images", values);

		const response = await apiClient.post("/image-upload", formData);

		return response.data;
	},
};

export default articleService;
